import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

function WrapperDnD(props) {
	return (
		<DragDropContext onDragEnd={props.onDragEnd} onDragStart={props.onDragStart}>
			{props.children} </DragDropContext>
	);
}

export default WrapperDnD;
